// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"196":"4d2b66e5","297":"7ab1ac29"}[chunkId] + ".js";
};